import React from 'react';
import MicroApp from '@/components/micro-app';
import env from '@/env';
import history from '@/history';

function Jinghailu() {
  return (
    <MicroApp
      url={env.JINGHAILU}
      name="Jinghailu"
      destory
      data={{ yxHistory: history, novelLink: '/information-center' }}
    />
  );
}

export default Jinghailu;
